import { io, Socket } from "socket.io-client";
import { baseApiURL } from "./baseApiUrl";
import { getRawToken, getToken } from "../utils/tokenFunctions";

function resolveToken(): string | null {
  let token = getToken() || getRawToken();

  if (!token) {
    console.warn("[socketClient] No existe token válido para iniciar conexión WebSocket.");
    return null;
  }

  return `Bearer ${token}`;
}

export let socket: Socket | null = null;

export function connectSocket() {
  const authToken = resolveToken();
  if (!authToken) {
    console.warn("[socketClient] No se puede conectar socket: falta token.");
    return;
  }

  if (!baseApiURL) {
    console.warn("[socketClient] No se puede conectar socket: falta baseApiURL.");
    return;
  }

  if (!socket) {
    socket = io(baseApiURL, {
      transports: ["websocket"],
      autoConnect: false,
    });
    console.info("[socketClient] Socket creado (autoConnect=false).");
  }

  // Se actualiza token SIEMPRE antes de conectar
  socket.auth = { token: authToken };

  if (!socket.connected) {
    socket.connect();
    console.info("[socketClient] Intentando conectar socket con token actual.");
  }
}

export function disconnectSocket() {
  if (socket) {
    socket.off(); 
    socket.disconnect();
    socket = null;
    console.info("[socketClient] Socket desconectado y limpiado.");
  }
}
